module.exports = "/_next/static/pages/test-guidelines/409bfd7ff305cff4b6362f71ba723ba5.png";